/**
 * @generated SignedSource<<f968691d29faf53f9080677ed3f0566e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecommendedProductsQuery$variables = {
  hubId: string;
};
export type RecommendedProductsQuery$data = {
  readonly hub: {
    readonly products: {
      readonly nodes: ReadonlyArray<{
        readonly stock: number;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"ProductTrackFragment">;
    };
  };
};
export type RecommendedProductsQuery = {
  response: RecommendedProductsQuery$data;
  variables: RecommendedProductsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "hubId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "pagination",
    "value": {
      "page": 0,
      "pageSize": 1000000
    }
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stock",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "name": "outOfStock",
  "args": null,
  "fragment": {
    "kind": "InlineFragment",
    "selections": (v4/*:: as any*/),
    "type": "HubProduct",
    "abstractKey": null
  },
  "kind": "RelayResolver",
  "storageKey": null,
  "isOutputType": true
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecommendedProductsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "Hub",
          "kind": "LinkedField",
          "name": "hub",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*:: as any*/),
              "concreteType": "HubProductPage",
              "kind": "LinkedField",
              "name": "products",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductTrackFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HubProduct",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": (v4/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": "products(pagination:{\"page\":0,\"pageSize\":1000000})"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RecommendedProductsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "HubProductPage",
            "kind": "LinkedField",
            "name": "products",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubProduct",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceAmount",
                    "storageKey": null
                  },
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Brand",
                        "kind": "LinkedField",
                        "name": "brand",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Category",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "i18N",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CloudflareImage",
                        "kind": "LinkedField",
                        "name": "photo",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "variant",
                                "value": "PUBLIC"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "variant",
                            "storageKey": "variant(variant:\"PUBLIC\")"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "products(pagination:{\"page\":0,\"pageSize\":1000000})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8d79e44b0085ac880f9872d36204713",
    "id": null,
    "metadata": {},
    "name": "RecommendedProductsQuery",
    "operationKind": "query",
    "text": "query RecommendedProductsQuery(\n  $hubId: UUID!\n) {\n  hub(id: $hubId) {\n    products(pagination: {page: 0, pageSize: 1000000}) {\n      ...ProductTrackFragment\n      nodes {\n        stock\n      }\n    }\n  }\n}\n\nfragment ProductCardFragment on HubProduct {\n  id\n  priceAmount\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n  stock\n  ...clientResolversOutOfStockFragment\n}\n\nfragment ProductTrackFragment on HubProductPage {\n  nodes {\n    id\n    stock\n    priceAmount\n    ...clientResolversOutOfStockFragment\n    product {\n      id\n      name\n      brand {\n        id\n        organization {\n          id\n          name\n        }\n      }\n      category {\n        id\n        name\n      }\n    }\n    ...ProductCardFragment\n  }\n}\n\nfragment clientResolversOutOfStockFragment on HubProduct {\n  stock\n}\n"
  }
};
})();

(node as any).hash = "7d2380b2a8d16380869dece85c74410b";

export default node;
